/* System defined core library */
import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core';

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { Candidate } from '../../../../shared/models/scheduling/candidate.model';
import { Payment } from '../../../../shared/models/scheduling/payment.model';

/* User defined library/components */
import { BootstrapParams } from '../../../../../bootstrap-params';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';


@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html'
})
export class PaymentDetailComponent {

  // used to map paymentFeeDetail.transactionType to corresponding translation keys
  public feeMap = {
    'Schedule Fee': 'paymentDetailComponent.ScheduleFee',
    'Reschedule Fee': 'paymentDetailComponent.rescheduleFee',
    'Cancel Fee': 'paymentDetailComponent.cancelFee',
    'Cancel Refund': 'paymentDetailComponent.cancelRefund'
  };

  public candidate: Candidate;
  public displayTaxDisclaimer: boolean;
  public taxAmt: number;
  public isPaymentRequired: boolean;

  translateLanguage$: Subscription;
  candidate$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() public targetFlow: string;
  @Input() public selectedAppointments: AppointmentDetail[];
  @Input() public totalAmount: number = 0;
  @Input() public refundAmount: number = 0;
  @Input() public currencyCode: string = 'USD';
  @Input() public refundCurrency: string = 'USD';

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private bootstrapParams: BootstrapParams,
    private translate: TranslateService
  ) {
    this.candidate$ = this.selectedExamDetailService.candidate.subscribe(
      candidate => {
        this.candidate = candidate;
      }
    );

    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
  }

  // assign it some default value to be on safer side
  ngOnInit() {
    if (!this.currencyCode) this.currencyCode = 'USD';

    this.isPaymentRequired = this.selectedExamDetailService.isPaymentRequired;

    const isProctored = this.selectedExamDetailService.isProctored || !!this.selectedAppointments[0].appointmentSlot.proctorTimeZone;
    if (this.bootstrapParams.displayTaxDisclaimer && (!isProctored && this.selectedAppointments[0].appointmentSlot.site.location.address.country === 'IND')) {
      this.displayTaxDisclaimer = true;
      this.taxAmt = 18;
    }
  }

  getCurrencyCode(paymentFeeDetail: Payment) {
    if (paymentFeeDetail && paymentFeeDetail.currency) {
      return paymentFeeDetail.currency.toString();
    }
    return 'USD';
  }

  showRefund(): boolean {
    return this.targetFlow === 'Cancellation'
      && this.selectedExamDetailService.isRefundRequired
      && !this.selectedExamDetailService.isPaymentRequired
      && this.refundAmount > 0;
  }
}
